<!--
 * @Author: yaoling 1871883713@qq.com
 * @Date: 2022-12-12 15:57:31
 * @LastEditors: yaoling 1871883713@qq.com
 * @LastEditTime: 2023-01-04 15:51:01
 * @FilePath: \saas-front\src\views\homePage\components\HoverPicture.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flip-picture">
		<div
			class="card"
			v-for="item in dataList"
			:key="item.id"
		>
			<div class="show-card show-card-front">
				<img :src="item.icon" />
			</div>
			<div class="show-card show-card-back">
				<img :src="item.hoverIcon" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HoverPicture',
	components: {},
	props: {
		dataList: {
			type: Array,
			required: true,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
.card:hover .show-card-front {
	transform: rotateY(0.5turn);
}
.card:hover .show-card-back {
	transform: rotateY(0);
}
.flip-picture {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 0 1%;
	box-sizing: border-box;
	.card {
		position: relative;
		width: 15.5%;
		height: 100px;
		cursor: pointer;
		transition: 1s ease-in-out;
		transform-style: preserve-3d;
		.show-card {
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #fff;
			backface-visibility: hidden;
			transition: 1s ease-in-out;
			img {
				width: 100%;
				-o-object-fit: cover;
				object-fit: cover;
			}
		}
	}
}
.show-card-back {
	transform: rotateY(0.5turn);
}
</style>
